import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Notification from './../Notification'
import { setActiveChat } from '../../../store/ducks/chat'
import { setAsRead } from '../../../store/ducks/aside'
import { getChannels } from '../../../services/channels'
import './styles.scss'

function Aside ({ setActiveChat, setAsRead }) {
  const [id, setId] = React.useState('')
  const channels = getChannels()

  function handleActive (id, name) {
    setActiveChat(id, name)
    setId(id)
    setAsRead(id)
  }

  return (
    <aside className='channels'>
      <h1 className='channels__brand'>XYZ Company</h1>
      <nav className='channels__list'>
        <h2 className='channels__title'>Channels</h2>
        <ul>
          {channels.map((channel, k) => (
            <li
              key={channel.id}
              onClick={() => handleActive(channel.id, channel.name)}
              className={
                channel.id === id
                  ? 'channels__item channels__item--active'
                  : 'channels__item'
              }
            >
              # {channel.name}
              <Notification id={channel.id} />
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  )
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setActiveChat, setAsRead }, dispatch)

const mapStateToProps = ({ aside }) => ({ aside })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Aside)
